import { styled, TextareaAutosize } from '@mui/material';

export const StyledTextArea = styled(TextareaAutosize)(({ theme }) => ({
  width: '100%',
  maxHeight: 350,
  fontFamily: 'Inter,Helvetica,Arial,sans-serif',
  ...theme.typography.body1,
}));
